<template>
  <b-container id="payment-status-page" class="d-flex flex-column align-items-center justify-content-center" v-if="orderDetails">
    <b-row id="contents">
      <b-col md="6" lg="4" class="mx-auto">
        <b-row>
          <b-col class="text-center">
            <img src="@/assets/images/img-failed.png" alt="Failed" />
            <div class="h2 mt-4">Payment Failed</div>
            <div class="mt-3 mb-4">We cannot process your payment. Please try again.</div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row id="button-container" class="mt-5">
      <b-col md="6" lg="4" class="mx-auto">
        <router-link
          class="btn btn-core btn-block border-0"
          :to="{ name: 'Cart' }"
          :style="{
            backgroundColor: `${design.main_color} !important`,
            color: `${design.button_text_color} !important`,
          }"
        >
          RETURN TO CART
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "PaymentFailed",
  computed: {
    ...mapState("auth", ["token"]),
    ...mapState("merchant", ["customerPortalToken"]),
    ...mapState("estore", ["orderDetails"]),
    ...mapGetters("estore", ["design"]),
  },
  filters: {
    currency(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    async getOrderDetails(id) {
      if (this.customerPortalToken) {
        const header = {
          "X-Merchant-Token": this.customerPortalToken
        };

        if (this.token) header["Authorization"] = this.token;

        await this.$store.dispatch(
          "estore/getOrderDetails",
          { header, id }
        );
      }
    },
    postFailed(message) {
      if (window.webkit && window.webkit.messageHandlers.appInterface)
        window.webkit.messageHandlers.appInterface.postFailed(message);

      if (window.appInterface) window.appInterface.postFailed(message);
    },
    postMessage(message) {
      if (window.webkit && window.webkit.messageHandlers.appInterface)
        window.webkit.messageHandlers.appInterface.postMessage(message);

      if (window.appInterface) window.appInterface.postMessage(message);
    },
  },
  async created() {
    const ios = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

    if (ios) this.postMessage({ success: false, message: 'Payment Failed'});
    else this.postFailed('Payment Failed');
    
    const { orderId } = this.$route.query;

    if (!orderId) {
      this.$router.push({ name: "Home" });

      return;
    }

    await this.getOrderDetails(orderId);
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/views/checkout/_payment-status.scss";
</style>